export const MOBILE_PAGE_CONFIG = {
  mobileConfig : ''
}